import React from 'react'
import { Form } from 'react-bootstrap'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector'
import { FormikErrors, FormikTouched } from 'formik'

interface DefaultAddressFieldsProps {
  values: {
    address1: string
    address2: string
    city: string
    region: string
    country: string
    zipCode: string
  }
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<{
    address1: string
    address2: string
    city: string
    region: string
    country: string
    zipCode: string
  }>
  handleChange: {
    (e: React.ChangeEvent<any>): void
    <T = string | React.ChangeEvent<any>>(
      field: T
    ): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void
  }
  handleBlur: {
    (e: React.FocusEvent<any>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  touched: FormikTouched<{
    address1: string
    address2: string
    city: string
    region: string
    country: string
    zipCode: string
  }>
}

const DefaultAddressFields: React.FC<DefaultAddressFieldsProps> = ({
  values,
  setFieldValue,
  errors,
  handleChange,
  handleBlur,
  touched
}) => {
  return (
    <div data-testid="defaultAddressFieldFC">
      <Form.Group>
        <Form.Label htmlFor="recipient-country">Country</Form.Label>
        <Form.Control
          id="recipient-country"
          as={CountryDropdown}
          name="country"
          value={values.country}
          data-testid="countryOption"
        />
      </Form.Group>
      <Form.Group>
        <Form.Label htmlFor="recipient-region">Region</Form.Label>
        <Form.Control
          id="recipient-region"
          as={RegionDropdown}
          name="region"
          value={values.region}
          onChange={val => {
            setFieldValue('region', val)
          }}
          country={values.country}
          data-testid="regionOption"
        />

        <Form.Control.Feedback type="invalid">
          {errors.region}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group>
        <Form.Label htmlFor="recipient-city">City</Form.Label>
        <Form.Control
          id="recipient-city"
          type="text"
          name="city"
          placeholder="type city"
          value={values.city}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.city && !!errors.city}
        />
        <Form.Control.Feedback type="invalid">
          {errors.city}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group>
        <Form.Label htmlFor="recipient-zipCode">Postal code</Form.Label>
        <Form.Control
          id="recipient-zipCode"
          type="text"
          name="zipCode"
          placeholder="type zipCode"
          value={values.zipCode}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.zipCode && !!errors.zipCode}
        />
        <Form.Control.Feedback type="invalid">
          {errors.zipCode}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group>
        <Form.Label htmlFor="recipient-address1">Address 1</Form.Label>
        <Form.Control
          id="recipient-address1"
          type="text"
          name="address1"
          placeholder="type address 1"
          value={values.address1}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.address1 && !!errors.address1}
        />
        <Form.Control.Feedback type="invalid">
          {errors.address1}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group>
        <Form.Label htmlFor="recipient-address2">Address 2</Form.Label>
        <Form.Control
          id="recipient-address2"
          type="text"
          name="address2"
          placeholder="type address 2"
          value={values.address2}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.address2 && !!errors.address2}
        />
        <Form.Control.Feedback type="invalid">
          {errors.address2}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  )
}

export default DefaultAddressFields
